import { isElectron } from "../utils/isElectron";

export const AIRLYTICS_ENDPOINT =
  "https://analytics.cubicle6.com/.netlify/functions/event";

export const AIRLYTICS_PID = "appMvfQ4dNXXfBs6l";

export const TRACKING_ENABLED =
  process.env.NODE_ENV === "production" && !isElectron();
